// Testimonials.js
import React, { useState, useEffect } from 'react';
import useIntersectionObserver from '../hooks/useIntersectionObserver';

const testimonials = [
  {
    name: "Sarah Johnson",
    role: "CTO, TechCorp",
    content: "MYAC transformed our development process. Their AI solutions helped us reduce deployment time by 60%.",
    rating: 5
  },
  {
    name: "Michael Chen",
    role: "Product Manager, InnovateLab",
    content: "The team's expertise in cloud engineering is outstanding. They delivered beyond our expectations.",
    rating: 5
  },
  {
    name: "Emily Rodriguez",
    role: "CEO, StartupFlow",
    content: "Working with MYAC was a game-changer. Their modern approach to product engineering is impressive.",
    rating: 5
  }
];

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [ref, isIntersecting, hasIntersected] = useIntersectionObserver();

  useEffect(() => {
    if (!hasIntersected) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [hasIntersected]);

  const currentTestimonial = testimonials[currentIndex];

  return (
    <section className="testimonials-section section light" ref={ref}>
      <div className="container">
        <h2 className="section-title">What Our Clients Say</h2>
        <div className={`testimonial-card ${hasIntersected ? 'animate-in' : ''}`}>
          <div className="testimonial-content">
            <div className="stars">
              {Array.from({ length: currentTestimonial.rating }, (_, i) => (
                <span key={i} className="star">⭐</span>
              ))}
            </div>
            <blockquote>"{currentTestimonial.content}"</blockquote>
            <div className="testimonial-author">
              <strong>{currentTestimonial.name}</strong>
              <span>{currentTestimonial.role}</span>
            </div>
          </div>
        </div>
        <div className="testimonial-dots">
          {testimonials.map((_, index) => (
            <button
              key={index}
              className={`dot ${index === currentIndex ? 'active' : ''}`}
              onClick={() => setCurrentIndex(index)}
              aria-label={`Go to testimonial ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;